export default __webpack_public_path__ + "static/media/sleeping.4456f72c.png";